import * as React from 'react'

import { useReadAloud } from './readAloudContext'
import { SpeakerIcon } from './speechIcons'

import { isTextToSpeechSupported } from '../../libs/speech/speechManager'

interface ListenToggleButtonProps {
  buttonRef?: React.Ref<HTMLButtonElement>;
  children?: React.ReactNode;
  controlsId?: string;
  listening: boolean;
  onToggle: () => void;
}

const ListenToggleButton = ({ buttonRef, children, controlsId, listening, onToggle, }: ListenToggleButtonProps) => {
  const { readAloudEnabled, } = useReadAloud()

  if (!readAloudEnabled || !isTextToSpeechSupported()) { return null }

  return (
    <div className="article-actions-bar">
      <button aria-controls={controlsId} aria-pressed={listening} className="listen-button quill-button focus-on-light medium outlined grey" onClick={onToggle} ref={buttonRef} type="button">
        <SpeakerIcon />
        <span>{listening ? 'Stop listening' : 'Listen'}</span>
      </button>
      {children}
    </div>
  )
}

export { ListenToggleButton }
